module.exports = function (items, key) {
    return items.reduce(function (acc, x) {
        (acc[x[key]] = acc[x[key]] || []).push(x);
        return acc;
    }, {});
};
